import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Autocomplete } from '@material-ui/lab'
import SimpleInput from 'app/componentV4/Input/SimpleInput'
import { makeStyles } from '@material-ui/core'
import { isEmpty, filter, includes } from 'ramda'
import effects from 'app/effects/effects'
import { useIntl } from 'react-intl'

const useStyles = makeStyles((theme) => ({
  endAdornment: {
    width: '100%',
    position: 'absolute',
    right: 10,
    top: '50%',
    transform: 'translateY(-50%)',
  },
}))

const CountrySelector = ({
  id,
  value,
  onChange,
  placeholder,
  className,
  countries,
}) => {
  const classes = useStyles()

  const { formatMessage } = useIntl()

  return (
    <Autocomplete
      options={countries}
      getOptionLabel={(option) => `${option.name}(${option.code})`}
      value={countries.find((g) => g.id === value) || null}
      className={className}
      noOptionsText={formatMessage({
        id: 'crm.form.receiveMethods.option.empty',
      })}
      onChange={(event, newValue) => {
        if (onChange) {
          onChange(newValue ? newValue : {})
        }
      }}
      renderInput={(params) => (
        <div ref={params.InputProps.ref} className="w-full">
          <SimpleInput
            id={id}
            placeholder={placeholder}
            endAdornment={
              <div className={classes.endAdornment}>
                {params.InputProps.endAdornment}
              </div>
            }
            size="medium"
            fullWidth
            {...params}
          />
        </div>
      )}
    />
  )
}

CountrySelector.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  prefer: PropTypes.array,
}

export default CountrySelector
